import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope16v8y7h9n9146 as coroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { headers24pki7ce1busg as headers } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/HttpRequest.mjs';
import { url1qder21xodqzl as url } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/buildersWithUrl.mjs';
import { webSocket1c0mdzi4rb3bo as webSocket } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/builders.mjs';
import { DefaultClientWebSocketSession1n8ok3lng45wy as DefaultClientWebSocketSession } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/ClientSessions.mjs';
import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  Urlowwyg1lanrqp as Url,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import {
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstancetfg6b5k18hsf as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Close3tx65evcwi73t as Close,
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
} from '../../../../../ktor-ktor-websockets/io/ktor/websocket/Frame.web.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { readText30p9xkeoodw49 as readText } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/FrameCommon.mjs';
import { Plugin_getInstancefllmgjpjiqqy as Plugin_getInstance } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/WebSockets.mjs';
import { CloseReason10cphaqpp3ct7 as CloseReason } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/CloseReason.mjs';
import { Dispatchers_getInstancewbokwrm9sosb as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { HttpClient3584jcajl7sef as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = sendFrames($this.b6d_1, $this.c6d_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  launch($this$coroutineScope, VOID, VOID, KtorWebSocketEngine$open$slambda$slambda$slambda$slambda_0($this.d6d_1, $this.e6d_1));
  try {
    var tmp = receiveFrames($this.d6d_1, $this.e6d_1.s59(), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      var tmp_0 = closeReasonOrNull($this.d6d_1, $this.e6d_1, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var closeReason = tmp_0;
      var tmp_1;
      if (!(closeReason == null)) {
        tmp_1 = ApolloWebSocketClosedException().t4d(closeReason.j59_1, closeReason.k59_1, e);
      } else {
        tmp_1 = ApolloNetworkException().d47('Web socket communication error', e);
      }
      var apolloException = tmp_1;
      $this.d6d_1.w6c_1.p1b(apolloException);
      throw e;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
var KtorWebSocketEngine$open$slambda$slambda$slambda$slambdaClass;
function KtorWebSocketEngine$open$slambda$slambda$slambda$slambda() {
  if (KtorWebSocketEngine$open$slambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_webSocket) {
        this.b6d_1 = this$0;
        this.c6d_1 = $this_webSocket;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    KtorWebSocketEngine$open$slambda$slambda$slambda$slambdaClass = $;
  }
  return KtorWebSocketEngine$open$slambda$slambda$slambda$slambdaClass;
}
function KtorWebSocketEngine$open$slambda$slambda$slambda$slambda_0(this$0, $this_webSocket) {
  var i = new (KtorWebSocketEngine$open$slambda$slambda$slambda$slambda())(this$0, $this_webSocket);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$webSocket, $completion) {
  var tmp = coroutineScope(KtorWebSocketEngine$open$slambda$slambda$slambda_0($this.f6d_1, $this$webSocket), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var KtorWebSocketEngine$open$slambda$slambda$slambdaClass;
function KtorWebSocketEngine$open$slambda$slambda$slambda() {
  if (KtorWebSocketEngine$open$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_webSocket) {
        this.d6d_1 = this$0;
        this.e6d_1 = $this_webSocket;
      }
      c1g($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    KtorWebSocketEngine$open$slambda$slambda$slambdaClass = $;
  }
  return KtorWebSocketEngine$open$slambda$slambda$slambdaClass;
}
function KtorWebSocketEngine$open$slambda$slambda$slambda_0(this$0, $this_webSocket) {
  var i = new (KtorWebSocketEngine$open$slambda$slambda$slambda())(this$0, $this_webSocket);
  var l = ($this$coroutineScope, $completion) => i.c1g($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  try {
    var tmp = ($this$webSocket) => {
      headers($this$webSocket, ($this$headers) => {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = $this.i6d_1.u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          $this$headers.h4o(element.s48_1, element.t48_1);
        }
        return Unit_instance;
      });
      url($this$webSocket, $this.h6d_1);
      return Unit_instance;
    };
    var tmp_0 = webSocket($this.g6d_1.u6c_1, tmp, KtorWebSocketEngine$open$slambda$slambda_0($this.g6d_1), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      $this.g6d_1.w6c_1.p1b(ApolloNetworkException().d47('Web socket communication error', e));
    } else {
      throw $p;
    }
  }
  finally {
    $this.g6d_1.w6c_1.p1b(ApolloNetworkException().d47('Web socket communication error', null));
  }
  return Unit_instance;
}
var KtorWebSocketEngine$open$slambda$slambdaClass;
function KtorWebSocketEngine$open$slambda$slambda() {
  if (KtorWebSocketEngine$open$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.f6d_1 = this$0;
      }
      j6d($this$webSocket, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$webSocket), $completion);
      }
      ud(p1, $completion) {
        return this.j6d(p1 instanceof DefaultClientWebSocketSession() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    KtorWebSocketEngine$open$slambda$slambdaClass = $;
  }
  return KtorWebSocketEngine$open$slambda$slambdaClass;
}
function KtorWebSocketEngine$open$slambda$slambda_0(this$0) {
  var i = new (KtorWebSocketEngine$open$slambda$slambda())(this$0);
  var l = ($this$webSocket, $completion) => i.j6d($this$webSocket, $completion);
  l.$arity = 1;
  return l;
}
function open($this, url, headers, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = URLBuilder(url);
  var tmp0_subject = url.d54_1;
  var tmp;
  if (tmp0_subject.equals(Companion_getInstance().p54_1)) {
    tmp = Companion_getInstance().r54_1;
  } else if (tmp0_subject.equals(Companion_getInstance().o54_1)) {
    tmp = Companion_getInstance().q54_1;
  } else if (tmp0_subject.equals(Companion_getInstance().q54_1) || tmp0_subject.equals(Companion_getInstance().r54_1)) {
    tmp = url.d54_1;
  } else {
    throw UnsupportedOperationException().f1('SOCKS is not a supported protocol');
  }
  this_0.n54(tmp);
  var newUrl = this_0.c37();
  launch($this.v6c_1, VOID, VOID, KtorWebSocketEngine$open$slambda_0($this, newUrl, headers));
  return new (KtorWebSocketEngine$open$5())($this);
}
function *_generator_closeReasonOrNull__98fze6($this, _this__u8e3s4, $completion) {
  var tmp;
  try {
    var tmp_0 = _this__u8e3s4.o59().yy($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var t = $p;
      if (t instanceof CancellationException()) {
        throw t;
      }
      tmp_1 = null;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function closeReasonOrNull($this, _this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_closeReasonOrNull__98fze6.bind(VOID, $this, _this__u8e3s4), $completion);
}
function *_generator_sendFrames__m3vqwq($this, session, $completion) {
  while (true) {
    var tmp = $this.x6c_1.i1b($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var frame = tmp;
    var tmp_0 = session.u59(frame, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    if (frame instanceof Close()) {
      $this.w6c_1.r1b();
    }
  }
  return Unit_instance;
}
function sendFrames($this, session, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sendFrames__m3vqwq.bind(VOID, $this, session), $completion);
}
function *_generator_receiveFrames__3ad21h($this, incoming, $completion) {
  while (true) {
    var tmp = incoming.i1b($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var frame = tmp;
    if (frame instanceof Text()) {
      $this.w6c_1.f1b(readText(frame));
    } else {
      if (frame instanceof Binary()) {
        $this.w6c_1.f1b(decodeToString(frame.s5a_1));
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unknown frame type';
        throw IllegalStateException().o(toString(message));
      }
    }
  }
  return Unit_instance;
}
function receiveFrames($this, incoming, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_receiveFrames__3ad21h.bind(VOID, $this, incoming), $completion);
}
function KtorWebSocketEngine$_init_$lambda_2axi3y($this$HttpClient) {
  $this$HttpClient.e5h(Plugin_getInstance());
  return Unit_instance;
}
var KtorWebSocketEngine$open$slambdaClass;
function KtorWebSocketEngine$open$slambda() {
  if (KtorWebSocketEngine$open$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $newUrl, $headers) {
        this.g6d_1 = this$0;
        this.h6d_1 = $newUrl;
        this.i6d_1 = $headers;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    KtorWebSocketEngine$open$slambdaClass = $;
  }
  return KtorWebSocketEngine$open$slambdaClass;
}
function KtorWebSocketEngine$open$slambda_0(this$0, $newUrl, $headers) {
  var i = new (KtorWebSocketEngine$open$slambda())(this$0, $newUrl, $headers);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var KtorWebSocketEngine$open$5Class;
function KtorWebSocketEngine$open$5() {
  if (KtorWebSocketEngine$open$5Class === VOID) {
    class $ {
      constructor(this$0) {
        this.k6d_1 = this$0;
      }
      i1b($completion) {
        return this.k6d_1.w6c_1.i1b($completion);
      }
      g6c(data) {
        this.k6d_1.x6c_1.f1b(Binary().b5e(true, data.b3x()));
      }
      h6c(string) {
        this.k6d_1.x6c_1.f1b(Text().l5e(string));
      }
      q6() {
        this.k6d_1.x6c_1.f1b(Close().g5b(CloseReason().l59(1000, '')));
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [0]);
    KtorWebSocketEngine$open$5Class = $;
  }
  return KtorWebSocketEngine$open$5Class;
}
var KtorWebSocketEngineClass;
function KtorWebSocketEngine() {
  if (KtorWebSocketEngineClass === VOID) {
    class $ {
      static y6c(client) {
        var $this = createThis(this);
        $this.u6c_1 = client;
        $this.v6c_1 = CoroutineScope_0(Dispatchers_getInstance().j13_1.om(SupervisorJob()));
        $this.w6c_1 = Channel(2147483647);
        $this.x6c_1 = Channel(2147483647);
        return $this;
      }
      static l6d() {
        return this.y6c(HttpClient(KtorWebSocketEngine$_init_$lambda_2axi3y));
      }
      y6b(url, headers, $completion) {
        return open(this, Url(url), headers, $completion);
      }
    }
    initMetadataForClass($, 'KtorWebSocketEngine', $.l6d, VOID, VOID, [2, 1]);
    KtorWebSocketEngineClass = $;
  }
  return KtorWebSocketEngineClass;
}
//region block: exports
export {
  KtorWebSocketEngine as KtorWebSocketEngine2cbfnq8i807su,
};
//endregion

//# sourceMappingURL=KtorWebSocketEngine.mjs.map
